import React from 'react';
import { Button } from '../shared/Button';
interface AITransparencyProps {
  userData: any;
  onComplete: () => void;
  onBack: () => void;
}
export const AITransparency = ({
  userData,
  onComplete,
  onBack
}: AITransparencyProps) => {
  // Helper function to format environment display
  const formatEnvironment = () => {
    if (!userData.environment) return '';
    // Handle both string and array formats
    const environments = Array.isArray(userData.environment) ? userData.environment : userData.environment.split(',');
    return environments.map(env => {
      switch (env) {
        case 'none':
          return 'No equipment needed';
        case 'bands':
          return 'Using bands & weights';
        case 'chair':
          return 'Chair-supported workouts';
        case 'space':
          return 'Open space exercises';
        default:
          return env;
      }
    }).join(', ');
  };
  return <div className="flex flex-col h-full p-6" data-id="element-652">
      <div className="mb-8" data-id="element-653">
        <button onClick={onBack} className="text-gray-500 mb-4" data-id="element-654">
          ← Back
        </button>
        <h1 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-655">
          How FitFuel uses AI to help you
        </h1>
        <div className="bg-blue-50 rounded-xl p-5 mb-6" data-id="element-656">
          <h2 className="font-semibold text-blue-800 mb-2" data-id="element-657">
            Your personalized plan
          </h2>
          <p className="text-blue-700 text-sm" data-id="element-658">
            We've created a plan tailored to your choices, including:
          </p>
          <ul className="mt-3 space-y-2 text-sm text-blue-700" data-id="element-659">
            {userData.name && <li className="flex items-start" data-id="element-660">
                <span className="mr-2" data-id="element-661">✓</span>
                <span data-id="element-662">Personalized for {userData.name}</span>
              </li>}
            {userData.timePreference && <li className="flex items-start" data-id="element-663">
                <span className="mr-2" data-id="element-664">✓</span>
                <span data-id="element-665">{userData.timePreference}-minute workouts</span>
              </li>}
            {userData.energyLevel && <li className="flex items-start" data-id="element-666">
                <span className="mr-2" data-id="element-667">✓</span>
                <span data-id="element-668">
                  {userData.energyLevel.charAt(0).toUpperCase() + userData.energyLevel.slice(1)}{' '}
                  energy level exercises
                </span>
              </li>}
            {userData.focusArea && <li className="flex items-start" data-id="element-669">
                <span className="mr-2" data-id="element-670">✓</span>
                <span data-id="element-671">
                  {userData.focusArea === 'stress' ? 'Stress relief' : userData.focusArea === 'strength' ? 'Strength building' : userData.focusArea === 'cardio' ? 'Cardio focus' : 'Mixed exercises'}
                </span>
              </li>}
            {userData.environment && <li className="flex items-start" data-id="element-672">
                <span className="mr-2" data-id="element-673">✓</span>
                <span data-id="element-674">{formatEnvironment()}</span>
              </li>}
            {userData.goal && <li className="flex items-start" data-id="element-675">
                <span className="mr-2" data-id="element-676">✓</span>
                <span data-id="element-677">
                  Goal:{' '}
                  {userData.goal.charAt(0).toUpperCase() + userData.goal.slice(1)}
                </span>
              </li>}
            {userData.schedule && <li className="flex items-start" data-id="element-678">
                <span className="mr-2" data-id="element-679">✓</span>
                <span data-id="element-680">
                  {userData.schedule.charAt(0).toUpperCase() + userData.schedule.slice(1)}{' '}
                  schedule preference
                </span>
              </li>}
          </ul>
        </div>
        <p className="text-gray-600 mb-6" data-id="element-681">
          Our AI continuously learns from your feedback to improve
          recommendations. Your data is secure and only used to enhance your
          experience.
        </p>
        <div className="bg-gray-100 rounded-xl p-4 mb-6" data-id="element-682">
          <p className="text-sm text-gray-600" data-id="element-683">
            You can update your preferences anytime in Settings. We'll adjust
            your plan accordingly.
          </p>
        </div>
      </div>
      <div className="mt-auto" data-id="element-684">
        <Button onClick={onComplete} variant="primary" fullWidth data-id="element-685">
          Let's Get Started! 🎉
        </Button>
      </div>
    </div>;
};